console.clear();
window.scroll(0, 0);

import gsap from "gsap";
import * as THREE from 'three';
// import { OrbitControls } from 'https://cdn.jsdelivr.net/npm/three@0.121.1/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';

var scene = new THREE.Scene();

// Camera
var camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.01,
    1000
    );
camera.updateProjectionMatrix();
camera.lookAt(scene.position);
//----------------------
const realms = [];

// Render
var renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    canvas: document.querySelector('.tree__canvas')
});
renderer.setClearColor(0xffffff, 0);
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.domElement.style.position = 'fixed';
renderer.domElement.style.zIndex = '1';

// Window resize
window.addEventListener('resize', onWindowResize, false)
function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight
    camera.updateProjectionMatrix()
    renderer.setSize(window.innerWidth, window.innerHeight)
    render()
}
function render() {
    renderer.render(scene, camera)
}

// Raycaster
/* const pointer = new THREE.Vector2();
const raycaster = new THREE.Raycaster();

const onMouseMove = (event) => {
    // Calculate pointer position
    pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
    pointer.x = (event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(pointer, camera);
    const intersects = raycaster.intersectObjects( scene.children );

    for (let i = 0; i < intersects.length; i++) {
        console.log(intersects);
    }
}

window.addEventListener('mousemove', onMouseMove); */


/* const labelRenderer = new CSS2DRenderer();
labelRenderer.setSize( window.innerWidth, window.innerHeight );
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.zIndex = '2';
labelRenderer.domElement.style.top = '0px';
document.body.appendChild( labelRenderer.domElement ); */
//----------------------

// Controls
/* const controls = new OrbitControls(camera, renderer.domElement);
controls.minDistance = 1
controls.maxDistance = 9
controls.keyPanSpeed = 15
controls.screenSpacePanning = true */

//----------------------

// Sphere
// Asgard
realms[0] = new THREE.Mesh(
        new THREE.SphereGeometry(0.5, 50, 50), 
        new THREE.MeshPhongMaterial({
            map: new THREE.TextureLoader().load('../assets/map/asgard/map.png'),
            bumpMap: new THREE.TextureLoader().load('../assets/map/asgard/bump.png'),
            bumpScale : 0.05,
            /* specularMap: new THREE.TextureLoader().load('../assets/map/asgard/spec.png') */
        })
    );
realms[0].position.set(2.2, 2.9, 1);
scene.add(realms[0]);

//Vanaheim
realms[1] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/vanaheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/vanaheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/vanaheim/spec.png'), */
    })
);
realms[1].position.set(5, 1.2, 1.4);
scene.add(realms[1]);

//Jotunheim
realms[2] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/jotunheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/jotunheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/jotunheim/spec.png'), */
    })
);
realms[2].position.set(3.5, -4.3, 0.3);
scene.add(realms[2]);

//Midgard
realms[3] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/midgard/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/midgard/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/midgard/spec.png'), */
    })
);
realms[3].position.set(4, -0.3, 0.5);
scene.add(realms[3]);

// Muspelheim
realms[4] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/muspelheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/muspelheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/muspelheim/spec.png'), */
    })
);
realms[4].position.set(1.15, 1, 0.5);
scene.add(realms[4]);

// Svarta
realms[5] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/svarta/map.jpg'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/svarta/bump.jpg'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/svarta/spec.png'), */
    })
);
realms[5].position.set(3.2, -1.5, 0);
scene.add(realms[5]);

// Alfheim
realms[6] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/alfheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/alfheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/alfheim/spec.png'), */
    })
);
realms[6].position.set(0.2, 1.8, 2.6);
scene.add(realms[6]);

// Nifelheim
realms[7] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/nifelheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/nifelheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/nifelheim/spec.png'), */
    })
);
realms[7].position.set(1, -5.2, 1);
scene.add(realms[7]);

realms[8] = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 50, 50), 
    new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load('../assets/map/helheim/map.png'),
        bumpMap: new THREE.TextureLoader().load('../assets/map/helheim/bump.png'),
        bumpScale : 0.05,
        /* specularMap: new THREE.TextureLoader().load('../assets/map/helheim/spec.png'), */
    })
);
realms[8].position.set(2.5, -3, 0);
scene.add(realms[8]);

//----------------------

// Dom Events
/* const domEvents	= new THREEx.DomEvents(camera, renderer.domElement) */

//domEvents.addEventListener(asgard, 'click', event => {
    //camera.lookAt(asgard.position);
    //gsap.to(camera.position,
    //{x: 0.7, y: 2.5, z: 2.1, duration: 2, ease: 'power3.inOut'});
//})

/* domEvents.addEventListener(asgard, 'mouseover', event => {
    realms[0].scale.set(1.1, 1.1, 1.1);
}) */

//domEvents.addEventListener(asgard, 'mouseout', event => {
    //asgard.scale.set(1, 1, 1);
//})
realms[0].addEventListener('click', () => {
    console.log('WTF');
})
//----------------------

// Load GLTF object
var loader = new GLTFLoader();

var obj;
loader.load('../assets/old_tree/scene.gltf', function(gltf){
    obj = gltf.scene;
    gltf.scene.scale.set(1.7, 1.7, 1.7);
    obj.position.set(2, -3, 0);
    obj.rotation.set(0, -1, 0);
    scene.add(gltf.scene);
})
//---------------------

// Look at
const main = document.querySelector('.main');
const sectionAsgard = document.querySelector('.section-asgard');
const sectionTitleAsgard = document.querySelector('.section__realm--asgard');
const section = document.querySelectorAll('.section');
const sectionTitle = document.querySelectorAll('.section__realm');
const navButton = document.querySelectorAll('.nav__button');

function changeAsgard() {
    sectionAsgard.classList.remove('_hidden');
    sectionTitleAsgard.classList.remove('section__realm--hidden');
}

function activeButton(){
    for (let i = 0; i < navButton.length; i++) {
        if(navButton[i].classList.contains('_active')){
            navButton[i].classList.remove('_active');
        }
    }
}

function hideAll(){
    for (let i = 0; i < section.length; i++) {
        if(section[i].classList.contains('_hidden')){
            console.log('Good')
        } else {
            section[i].classList.add('_hidden');
        }
    }
}

function hideAllTitle() {
    for (let i = 0; i < sectionTitle.length; i++) {
        if(sectionTitle[i].classList.contains('section__realm--hidden')){
            console.log('Good')
        } else {
            sectionTitle[i].classList.add('section__realm--hidden');
        }
    }
}

function unlockScroll(){
    let html = document.querySelector('html');
    if(html.classList.contains('_content-scroll')){
        console.log('OK');
    } else {
        html.classList.add('_content-scroll');
    }
}

function lockScroll(){
    let html = document.querySelector('html');
    if(html.classList.contains('_content-scroll')){
        html.classList.remove('_content-scroll');
    }
}

function hideBurger(){
    if(window.innerWidth < 1024){
        let navBlock = document.querySelector('.nav__block');
        navBlock.classList.toggle('nav__block--hidden');
        if(burgerButt.classList.contains('burger__el')){
            burgerButt.classList.remove('burger__el');
            burgerButt.classList.add('burger__cross');
        }else if(burgerButt.classList.contains('burger__cross')){
            burgerButt.classList.remove('burger__cross');
            burgerButt.classList.add('burger__el');
        }
    }
}

function regroupChanges() {
    hideAll();
    hideAllTitle();
    lockScroll();
    activeButton();
    hideBurger()
    window.scroll(0, 0);
}

const btnAsgard = document.querySelector('.btn-asgard');
btnAsgard.addEventListener('click', () => {
    hideAll();
    hideAllTitle();
    activeButton();
    hideBurger();
    navButton[0].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 2.6, y: 2.8, z: 2.1, duration: 2, ease: 'power3.inOut'});
    setTimeout(changeAsgard, 1800);
    setTimeout(unlockScroll, 1800);
})

const btnHelheim = document.querySelector('.btn-helheim');
btnHelheim.addEventListener('click', () => {
    regroupChanges()
    navButton[1].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 2.9, y: -3.1, z: 1.1, duration: 2, ease: 'power3.inOut'});
})

const btnAlfheim = document.querySelector('.btn-alfheim');
btnAlfheim.addEventListener('click', () => {
    regroupChanges()
    navButton[2].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: -0.4, y: 1.7, z: 3.8, duration: 2, ease: 'power3.inOut'});
})

const btnVana = document.querySelector('.btn-vana');
btnVana.addEventListener('click', () => {
    regroupChanges()
    navButton[3].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 4.5, y: 1.1, z: 2.65, duration: 2, ease: 'power3.inOut'});
})

const btnJotun = document.querySelector('.btn-jotun');
btnJotun.addEventListener('click', () => {
    regroupChanges()
    navButton[4].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 3, y: -4.4, z: 1.55, duration: 2, ease: 'power3.inOut'});
})
// realms[2].position.set(3.2, -4.5, 0);

const btnMidgard = document.querySelector('.btn-midgard');
btnMidgard.addEventListener('click', () => {
    regroupChanges()
    navButton[5].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 4.4, y: -0.4, z: 1.65, duration: 2, ease: 'power3.inOut'});
})
//midgard.position.set(2, -0.3, 0.5);

const btnMuspel = document.querySelector('.btn-muspel');
btnMuspel.addEventListener('click', () => {
    regroupChanges()
    navButton[6].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 1.6, y: 1, z: 1.6, duration: 2, ease: 'power3.inOut'});
})
//muspelheim.position.set(-0.85, 1, 0.5);

const btnSvarta = document.querySelector('.btn-svarta');
btnSvarta.addEventListener('click', () => {
    regroupChanges()
    navButton[7].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 2.7, y: -1.6, z: 1.15, duration: 2, ease: 'power3.inOut'});
})
//svarta.position.set(1.2, -1.5, 0);


const btnNifel = document.querySelector('.btn-nifel');
btnNifel.addEventListener('click', () => {
    regroupChanges()
    navButton[8].classList.add('_active');
    main.classList.add('_hidden');
    gsap.to(camera.position,
    {x: 1.4, y: -5.2, z: 2.2, duration: 2, ease: 'power3.inOut'});
})
//realms[7].position.set(1.3, -5.2, 1); */

const logo = document.querySelector('.logo');
logo.addEventListener('click', () => {
    regroupChanges();
    main.classList.remove('_hidden');
    gsap.to(camera.position,
    {x: 0, y: 0, z: 10, duration: 2, ease: 'power3.inOut'});
    if(window.innerWidth < 768 && burgerButt.classList.contains('burger__cross')){
        let navBlock = document.querySelector('.nav__block');
        navBlock.classList.toggle('nav__block--hidden');
        if(burgerButt.classList.contains('burger__cross')){
            burgerButt.classList.remove('burger__cross');
            burgerButt.classList.add('burger__el');
        }
    }
})

console.log(camera.position);
//----------------------

// Label ---------------
/* const sphereRadius = 0.5;

const asgardDiv = document.createElement('div');
asgardDiv.className = 'label';
asgardDiv.textContent = 'Asgard';
asgardDiv.style.marginTop = '0';
const asgardLabel = new CSS2DObject( asgardDiv );
asgardLabel.position.set(0, 0.25, 0);
asgard.add( asgardLabel );
asgardLabel.layers.set( 0 ); */

// ----- Direction light -----
const Ambiantlight = new THREE.AmbientLight( 0xffffff, 0.4 ); // soft white light
Ambiantlight.position.set( 0, 3, 1 );
scene.add( Ambiantlight );

const light = new THREE.DirectionalLight( 0xffffff, 0.8 );
light.position.set( 0, 1, 1 ).normalize();
scene.add(light);
//----------------------

camera.position.set(0, 0, 10);
function animate(){
    requestAnimationFrame(animate);
    // Realms rotation
    realms[0].rotation.y += 0.003;
    realms[1].rotation.y += 0.005;
    realms[2].rotation.y += 0.002;
    realms[3].rotation.y += 0.005;
    realms[4].rotation.y -= 0.007;
    realms[5].rotation.y += 0.004;
    realms[6].rotation.y += 0.004;
    realms[7].rotation.y -= 0.005;
    realms[8].rotation.y += 0.005;
    //-----------------
    renderer.render(scene, camera);
    //labelRenderer.render( scene, camera );
    //controls.update();
}
animate();

// x: 2.011409889058494
// y: 3.123536536353331
// z: 0.8888422463806903

//Burger Menu

const burger = document.querySelector('.burger-menu');
const burgerButt = document.querySelector('.burger-butt');

burger.addEventListener('click', () => {
    let navBlock = document.querySelector('.nav__block');
    navBlock.classList.toggle('nav__block--hidden');
    if(burgerButt.classList.contains('burger__el')){
        burgerButt.classList.remove('burger__el');
        burgerButt.classList.add('burger__cross');
    }else if(burgerButt.classList.contains('burger__cross')){
        burgerButt.classList.remove('burger__cross');
        burgerButt.classList.add('burger__el');
    }
})

console.log(window.innerWidth)

const firstImgEl = document.querySelector('.infos__img-el--first');
const secondImgEl = document.querySelector('.infos__img-el--second');
const thirdImgEl = document.querySelector('.infos__img-el--third');
const fourImgEl = document.querySelector('.infos__img-el--four');

firstImgEl.addEventListener('click', odin);
secondImgEl.addEventListener('click', thor);
thirdImgEl.addEventListener('click', frigg);
fourImgEl.addEventListener('click', baldur);

const sliderEl = ['odin', 'thor', 'frigg', 'baldur', 'heimdall', 'loki', 'vidar'];
const functionName = [odin, thor, frigg, baldur, heimdall, loki, vidar];
const container = document.querySelector('.section__infos');

const buttonThor = document.querySelector('.thor__active');
const buttonOdin = document.querySelector('.odin__active');
const buttonFrigg = document.querySelector('.frigg__active');
const buttonBaldur = document.querySelector('.baldur__active')
const buttonHeimdall = document.querySelector('.heimdall__active');
const buttonLoki = document.querySelector('.loki__active');
const buttonVidar = document.querySelector('.vidar__active');

function checkClass(){
    for (let i = 0; i < functionName.length; i++) {
        firstImgEl.removeEventListener('click', functionName[i]);
        secondImgEl.removeEventListener('click', functionName[i]);
        thirdImgEl.removeEventListener('click', functionName[i]);
        fourImgEl.removeEventListener('click', functionName[i]);
    }

    if(container.classList.contains('odin')){

        firstImgEl.addEventListener('click', odin);
        secondImgEl.addEventListener('click', thor);
        thirdImgEl.addEventListener('click', frigg);
        fourImgEl.addEventListener('click', baldur);

    } else if(container.classList.contains('thor')){

        firstImgEl.addEventListener('click', thor);
        secondImgEl.addEventListener('click', frigg);
        thirdImgEl.addEventListener('click', baldur);
        fourImgEl.addEventListener('click', heimdall);

    } else if(container.classList.contains('frigg')){

        firstImgEl.addEventListener('click', frigg);
        secondImgEl.addEventListener('click', baldur);
        thirdImgEl.addEventListener('click', heimdall);
        fourImgEl.addEventListener('click', loki);

    } else if(container.classList.contains('baldur')){

        firstImgEl.addEventListener('click', baldur);
        secondImgEl.addEventListener('click', heimdall);
        thirdImgEl.addEventListener('click', loki);
        fourImgEl.addEventListener('click', vidar);

    } else if(container.classList.contains('heimdall')){

        firstImgEl.addEventListener('click', heimdall);
        secondImgEl.addEventListener('click', loki);
        thirdImgEl.addEventListener('click', vidar);
        fourImgEl.addEventListener('click', odin);

    } else if(container.classList.contains('loki')){

        firstImgEl.addEventListener('click', loki);
        secondImgEl.addEventListener('click', vidar);
        thirdImgEl.addEventListener('click', odin);
        fourImgEl.addEventListener('click', thor);

    } else if(container.classList.contains('vidar')){

        firstImgEl.addEventListener('click', vidar);
        secondImgEl.addEventListener('click', odin);
        thirdImgEl.addEventListener('click', thor);
        fourImgEl.addEventListener('click', frigg);

    }
}

console.log(container);
// Remove toute les classes
/* for (let i = 0; i < sliderEl.length; i++) {
    console.log(sliderEl[i]);
} */

function odin(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('odin');
    checkClass();
}


function thor(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('thor');
    checkClass();
}

function frigg(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('frigg');
    checkClass();
}

function baldur(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('baldur');
    checkClass();
}

function heimdall(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('heimdall');
    checkClass();
}

function loki(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('loki');
    checkClass();
}

function vidar(){
    for (let i = 0; i < sliderEl.length; i++) {
        container.classList.remove(sliderEl[i]);
    }
    container.classList.add('vidar');
    checkClass();
}

/* if(container.classList.contains('odin')){
    secondImgEl.addEventListener('click', Thor());
} else if(container.classList.contains('thor')){
    firstImgEl.addEventListener('click', Thor());
} */

buttonThor.addEventListener('click', thor);
buttonOdin.addEventListener('click', odin);
buttonFrigg.addEventListener('click', frigg);
buttonBaldur.addEventListener('click', baldur);
buttonHeimdall.addEventListener('click', heimdall);
buttonLoki.addEventListener('click', loki);
buttonVidar.addEventListener('click', vidar);

window.addEventListener('scroll', () => {
    let navBlock = document.querySelector('.nav__block');
    if(window.scrollY >= 525){
        navBlock.classList.add('_bg-scroll');
    } else if(window.scrollY < 525){
        navBlock.classList.remove('_bg-scroll');
    }
})

console.log(window.scrollY)

// Credits

const buttCredits = document.querySelector('.footer__credits');
const crossCredits = document.querySelector('.cross');
const fullCredits = document.querySelector('.credits__fullscreen');

function creditsToggle() {
    let credits = document.querySelector('.credits');
    credits.classList.toggle('_hidden');
}

buttCredits.addEventListener('click', creditsToggle);
crossCredits.addEventListener('click', creditsToggle);
fullCredits.addEventListener('click', creditsToggle);